// features/services/hooks/queryKeys.js
export const servicesQueryKey = ["services"];
export const serviceQueryKey = (id) => ["services", id];
export const homepageDetailsQueryKey = ["homepageDetails"];
export const teamMembersQueryKey = ["teamMembers"];
export const teamMemberQueryKey = (id) => ["teamMember", id];
